import { useCallback } from 'react';

const useRazorpay = () => {
    const loadRazorpay = useCallback(() => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = 'https://checkout.razorpay.com/v1/checkout.js';
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    }, []);

    const initiatePayment = useCallback(async (options) => {
        const res = await loadRazorpay();

        if (!res) {
            alert('Razorpay SDK failed to load. Please check your internet connection.');
            return;
        }

        const keyId = process.env.REACT_APP_RAZORPAY_KEY_ID;
        if (!keyId) {
            console.error('REACT_APP_RAZORPAY_KEY_ID is not defined in the environment variables!');
            alert('Payment configuration error: Razorpay Key ID is missing in environment setup.');
            return;
        }

        const razorpayOptions = {
            key: keyId,
            amount: options.amount, // Amount in paise
            currency: 'INR',
            name: 'Yatharth Financial Services',
            description: options.description || 'Financial Diagnosis Report',
            image: '/logo512.png', // Your logo
            handler: function (response) {
                // Payment successful
                if (options.onSuccess) {
                    options.onSuccess(response);
                }
            },
            prefill: {
                name: options.prefill?.name || '',
                email: options.prefill?.email || '',
                contact: options.prefill?.contact || ''
            },
            notes: options.notes || {},
            theme: {
                color: '#003A70' // Vanguard navy blue
            },
            modal: {
                ondismiss: function () {
                    if (options.onDismiss) {
                        options.onDismiss();
                    }
                }
            }
        };

        const paymentObject = new window.Razorpay(razorpayOptions);

        paymentObject.on('payment.failed', function (response) {
            if (options.onFailure) {
                options.onFailure(response.error);
            }
        });

        paymentObject.open();
    }, [loadRazorpay]);

    return { initiatePayment };
};

export default useRazorpay;
